import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForRouteWiseCollectionTypeTotal } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { RouteWiseCollectionTypeReportSchemaObject } from "../RouteWiseCollectionTypeReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from "lodash";
import '../Pages/tableFooter.css';

import tokenDecoder from '../../../../Common/tokenDecoder';

const screenCode = "ROUTEWISECOLLECTIONTYPETOTALREPORT";

export function RouteWiseCollectionTypeReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [total, setTotal] = useState({
        totalWeight: 0,
        totalNetWeight: 0
    });

    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(RouteWiseCollectionTypeReportSchemaObject).options({ allowUnknown: true });
    const [contentRowNames, setContentRowNames] = useState([]);

    const [csvHeaders, setCsvHeaders] = useState([]);

    const initialColumnNames = ["Date", "Route"];
    const initialRowNames = ["date", "collectionPointName"];
    const initialCsvHeaders = [{ label: "Date", value: "date" }, { label: "Route", value: "collectionPointName" }];

    const [reportData, setReportData] = useState([]);
    const [columnNames, setColumnNames] = useState([]);
    const [totalFooter, setTotalFooter] = useState([]);
    const [footerFullTotal, setFooterFullTotal] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
        clearTableRelatedData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
        clearTableRelatedData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTableRelatedData();
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
        clearTableRelatedData();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, RouteWiseCollectionTypeReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTEWISECOLLECTIONTYPETOTALREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getRouteWiseCropeDetailsReportData(leafCollectionDetails);

        var formattedReportData = [];
        var contentRowNamesArray = initialRowNames;
        var columnNamesArray = initialColumnNames;
        var fullTotal = 0;

        result.forEach(x => {
            contentRowNamesArray.push(x.collectionTypeID);
            columnNamesArray.push(x.collectionTypeName + " (KG)");
            fullTotal = fullTotal + parseFloat(x.amount);

            if (formattedReportData.lenght === 0) {
                formattedReportData.push({
                    date: x.date.split("T")[0],
                    [x.collectionTypeID]: x.amount,
                    total: (parseFloat(x.amount)).toFixed(2),
                    collectionPointName: x.collectionPointName,
                    collectionPointID: x.collectionPointID,
                    collectionTypeName: x.collectionTypeName
                });
            } else {
                var isDuplicateRecord = formattedReportData.find(y => y.date === x.date.split("T")[0]
                    && parseInt(y.collectionPointID) === parseInt(x.collectionPointID));

                if (isDuplicateRecord) {
                    isDuplicateRecord[x.collectionTypeID] = x.amount;
                    isDuplicateRecord.total = (parseFloat(isDuplicateRecord.total) + parseFloat(x.amount)).toFixed(2);
                } else {
                    formattedReportData.push({
                        date: x.date.split("T")[0],
                        [x.collectionTypeID]: x.amount,
                        total: (parseFloat(x.amount)).toFixed(2),
                        collectionPointName: x.collectionPointName,
                        collectionPointID: x.collectionPointID,
                        collectionTypeName: x.collectionTypeName
                    });
                }
            }
        })

        contentRowNamesArray.push("total");
        columnNamesArray.push("Total");

        var uniqContentRowNamesArray = [...new Set(contentRowNamesArray)];
        var uniqColumnRowNamesArray = [...new Set(columnNamesArray)];

        setContentRowNames(uniqContentRowNamesArray);
        setColumnNames(uniqColumnRowNamesArray);
        setFooterFullTotal(fullTotal.toFixed(2));

        var totalRow = calculateTotalRow(result, formattedReportData, fullTotal.toFixed(2));
        setTotalFooter(totalRow);

        var csvHeaderResult = generateCsvHeaderData(uniqContentRowNamesArray, result);

        if (formattedReportData.length > 0) {
            destroyDataTable();
            setIsTableHide(false);
            setReportData(formattedReportData);
            createDataTable(uniqContentRowNamesArray, ["#routeWiseCropDetails", "#routeWiseCropDetailsPdf"]);
            setCsvHeaders(csvHeaderResult);
        }
    }

    function calculateTotalRow(data, formattedReportData, fullTotal) {

        var intialData = [];
        var formatData = [];
        var record = { date: "Total", collectionPointName: "" };

        data.forEach(x => {
            if (formatData.length === 0) {
                formatData.push({
                    id: x.collectionTypeID,
                    amount: parseFloat(x.amount),
                    collectionTypeID: x.collectionTypeID
                });
            } else {
                var duplicateResult = formatData.find(y => parseInt(y.collectionTypeID) === parseInt(x.collectionTypeID));

                if (duplicateResult) {
                    duplicateResult.amount = parseFloat(duplicateResult.amount) + parseFloat(x.amount);
                } else {
                    formatData.push({
                        id: x.collectionTypeID,
                        amount: parseFloat(x.amount),
                        collectionTypeID: x.collectionTypeID
                    });
                }
            }
        });

        formatData.forEach(x => {
            intialData.push(x.amount.toFixed(2));

            record[x.id] = x.amount.toFixed(2);
        });

        record.total = fullTotal;
        var csvFormattedData = _.cloneDeep(formattedReportData);
        csvFormattedData.push(record);

        csvFormattedData.unshift({}, {
            date: "Date: " + new Date().toLocaleString(),
            collectionPointName: "User: " + tokenService.getUserNameFromToken()
        }, {})

        setCsvData(csvFormattedData);

        return intialData;
    }

    function generateCsvHeaderData(data, reportDataArray) {
        var csvHeaders = initialCsvHeaders;

        data.forEach(x => {
            if (!isNaN(x)) {
                var selectedItem = reportDataArray.find(y => y.collectionTypeID === x);
                csvHeaders.push({
                    label: selectedItem.collectionTypeName, value: x
                })
            }
        });

        csvHeaders.push({ label: "Total", value: "total" });
        return csvHeaders;
    }

    function createDataTable(contentRowNames, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                order: [[1, "asc"]],
                destroy: x === '#routeWiseCropDetailsPdf' ? true : false,
                searching: x === '#routeWiseCropDetailsPdf' ? false : true,
                paging: x === '#routeWiseCropDetailsPdf' ? false : true,
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 0; i < contentRowNames.length; ++i) {
                            if (i > 1) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        return a + b * 1;
                                    }, 0);
                            }
                        }

                        var rowData = '';

                        for (var i = 0; i < contentRowNames.length; ++i) {
                            if (i > 1) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                            }
                        }

                        return $('<tr/>')
                            .append('<td colspan="2"><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 1
                }
            })
        });
    }

    function destroyDataTable() {
        $("#routeWiseCropDetails").DataTable().destroy();
    }

    function createFile() {
        var settings = {
            sheetName: 'Route Wise Collection Type',
            fileName: 'RouteWiseCollectionTypeTotalReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true);
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            collectionTypeID: "0",
            fromDate: "",
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Route Wise Collection Type Total"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div className="pt-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="routeWiseCropDetails" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            {columnNames.map((x, index) => {
                                                                return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForRouteWiseCollectionTypeTotal
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={2}>Total</th>
                                                            {totalFooter.map((x, index) => {
                                                                return (
                                                                    <th key={index} style={{ textAlign: "right" }}>{x}</th>
                                                                );
                                                            })}
                                                            <th style={{ textAlign: "right" }}>{footerFullTotal}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-3">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Route Wise Collection Type Total"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} total={total}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} columnNames={columnNames}
                                            footerFullTotal={footerFullTotal} totalFooter={totalFooter} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
